import type { ScheduledEmailAttachmentRef } from '@this+that/models';

import type { FileAttachment } from '../hooks/useFileAttachments';

interface Base64AttachmentSource {
  name: string;
  contentType: string;
  contentBytes: string;
}

export const fileAttachmentFromBase64 = ({
  name,
  contentType,
  contentBytes,
}: Base64AttachmentSource): FileAttachment => {
  const binary = atob(contentBytes);
  const byteArray = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  const file = new File([byteArray], name, { type: contentType });

  return { name, contentType, contentBytes, file };
};

export const fileAttachmentFromRef = ({
  name,
  contentType,
  s3Key,
  size,
}: ScheduledEmailAttachmentRef): FileAttachment => ({
  name,
  contentType,
  contentBytes: '',
  file: new File([], name, { type: contentType }),
  s3Key,
  size: size ?? undefined,
});
